import React from 'react';

import Meta from '@bizapp-lp/pjr/organisms/Meta';
import { Complete } from '@bizapp-lp/pjr/templates/Complete';

const title =
  'Project Room 無効なページ | 社内外とのプロジェクトを複数同時に進める現場のコラボレーションを支援・促進します';
const description =
  'Project Roomは、プロジェクトのための、簡単・安全に利用できるコミュニケーションツール。社外関係者も含めたプロジェクトメンバー全体のコミュニケーションを活性化し、エンゲージメントを向上します。プロジェクトで取り扱うファイルや予定の共有も一か所に集約でき、情報共有やノウハウ蓄積、共同作業をサポートします。';

const Page: React.FC = () => {
  return (
    <>
      <Meta>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
      </Meta>
      <Complete
        heading1="Project Room 無効ページ"
        heading2="無効なページです"
        description="申し訳ありません、こちらのページは無効となっております。"
      />
    </>
  );
};

const Invalid = React.memo(Page);
export default Invalid;
